// My requests: pending asks stay in the main table; every other status is "closed" and
// sits under a collapsed disclosure.
import type { MyRequest } from '../api/types';
import { isPendingRequest } from './bankRequest.ts';

export function splitRequests(requests: MyRequest[]): { pending: MyRequest[]; closed: MyRequest[] } {
  const pending = requests.filter(isPendingRequest);
  const closed = requests.filter(request => !isPendingRequest(request));
  return { pending, closed };
}

export function closedRequestsLabel(closedCount: number): string {
  return `Closed requests (${closedCount})`;
}
